import { messageUrl } from "../Config/Url";
import axios from "axios";

export const messageService = {
  get,
  create,
  createPos
};

async function get({
  tenantId,
  searchText,
  pageIndex,
  pageSize,
  sortName,
  isAsc,
}) {
  return axios
    .put(`${messageUrl}/search`, {
      tenantId,
      searchText,
      pageIndex,
      pageSize,
      sortName,
      isAsc,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function create({ tenantId, title, text }) {
  return axios
    .post(messageUrl, {
      tenantId,
      title,
      text,
    })
    .then((res) => res)
    .catch((err) => err.response);
}
async function createPos({ tenantId,posId, title, text }) {
  return axios
    .post(messageUrl+"/pos", {
      tenantId,
      posId,
      title,
      text,
    })
    .then((res) => res)
    .catch((err) => err.response);
}
